module.exports = __webpack_public_path__ + "static/covid19-091c0db8fe1176556100025bc4e0cd9a.png";